import type { PublicSlotKey } from '@/apilib';
import type { EditorRestrictionsApi } from './editorRestrictionsApi';

export const EditorRestrictionsApiKey: PublicSlotKey<EditorRestrictionsApi> = {
  name: 'EditorRestrictionsApi',
  public: true,
};
